<template>
  <div class="login">
    <h2 align="center">注册</h2>
  </div>
</template>

<script type="text/ecmascript-6">

export default {
  data() {
    return {};
  },
  methods: {},
  components: {},
  created() {
  },
  pass: true // 自动路由是否跳过
};
</script>

<style scoped lang="less">
</style>